/**
 * Sales benchmarks for remodelers / design-build firms.
 * Drives color coding and coaching cues on the Sales dashboard.
 */

export const SALES_BENCHMARKS = {
  closeRatio: {
    label: 'Close Ratio',
    unit: '%',
    good: 30,
    ok: 20,
    higherIsBetter: true,
    target: '25-35% for qualified leads'
  },
  revenueGrowth: {
    label: 'Revenue Growth',
    unit: '%',
    good: 10,
    ok: 0,
    higherIsBetter: true,
    target: '10%+ YoY growth'
  },
  pipelineValue: {
    label: 'Pipeline Value',
    unit: '$',
    good: 500000,
    ok: 200000,
    higherIsBetter: true,
    target: 'Healthy weighted pipeline'
  },
  partnerCount: {
    label: 'Active Partners',
    unit: '',
    good: 10,
    ok: 5,
    higherIsBetter: true,
    target: '10+ active referral partners'
  },
  awardsWon: {
    label: 'Awards Won',
    unit: '',
    good: 3,
    ok: 1,
    higherIsBetter: true,
    target: '3+ industry awards'
  }
};

export const getMetricStatus = (metricKey, value) => {
  const b = SALES_BENCHMARKS[metricKey];
  if (!b || value == null || Number.isNaN(value)) return 'none';
  if (b.higherIsBetter) {
    if (value >= b.good) return 'good';
    if (value >= b.ok) return 'ok';
    return 'poor';
  }
  if (value <= b.good) return 'good';
  if (value <= b.ok) return 'ok';
  return 'poor';
};

export const getCoachingCue = (metricKey, status) => {
  const b = SALES_BENCHMARKS[metricKey];
  if (!b) return '';
  if (status === 'good') return `Healthy. Target: ${b.target}.`;
  if (status === 'ok') return `Close to target. Aim for ${b.target}.`;
  if (status === 'poor') return `Below target. Goal: ${b.target}.`;
  return `Target: ${b.target}.`;
};
